interface Credentials {
    [key:string]: string|boolean;
}

interface DynamicCredentialsForm {
    // @ts-ignore
    linkTutorialCredentials?: string;
    [key:string]: {
        [key:string]: any;
        type: string;
        required?: boolean;
        readOnly?: boolean;
        value: string|boolean;
    };
}

interface Schema {
    title: string;
    type: string;
    linkTutorialCredentials?: string;
    properties: {
        [key:string]: {
            type: string;
            description: string;
            info?: string;
            required: boolean;
            readOnly?: boolean;
        }
    }
}   

export default {
    mergeCredentialsSchemaAndServerInformation(schema: Schema, credentials: Credentials):DynamicCredentialsForm {
        const form:DynamicCredentialsForm = {}

        const schemaProps = Object.keys(schema.properties).map((prop) => {
            return {
                key: prop,
                info: schema.properties[prop].info,
                type: schema.properties[prop].type,
                required: schema.properties[prop].required,
                readOnly: schema.properties[prop].readOnly,
                description: schema.properties[prop].description,
            }
        })

        for (const obj of schemaProps) {
            form[obj.key] = {                
                description: obj.description,
                type: obj.type,
                info: obj.info as string,
                value: credentials[obj.key],
                key: obj.key,
                readOnly: obj.readOnly || false,
                required: obj.required || false,
            }
        }

        return form
    },

    mountCredentialsObjectFromForm(credentialsForm: DynamicCredentialsForm):Credentials {
        const obj:Credentials = {}

        for (const prop in credentialsForm) {
            if ((typeof prop === 'string' || typeof prop === 'boolean') && prop !== null && prop !== 'null') {
                if (typeof credentialsForm[prop].value === 'string') {
                    obj[prop] = (credentialsForm[prop].value as string).trim()
                } else {
                    obj[prop] = credentialsForm[prop].value
                }
            }
        }

        return obj
    }
}

